import { COLOR_PRIMARY_2, COLOR_PRIMARY_2_600 } from "src/colors";

const commonButtonSx = {
    justifyContent: 'flex-start',
    boxShadow: 'none',
  };
  
  const containedButtonSx = {
    backgroundColor: COLOR_PRIMARY_2_600,
    color: 'white',
    borderColor: COLOR_PRIMARY_2,
    boxShadow: 1,
    '&:hover': {
      backgroundColor: COLOR_PRIMARY_2_600,
      borderColor: COLOR_PRIMARY_2_600,
      boxShadow: 3,
    },
  };
  
  const outlinedButtonSx = {
    borderColor: COLOR_PRIMARY_2,
    color: COLOR_PRIMARY_2,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'rgba(66, 85, 99, 0.04)',
      borderColor: COLOR_PRIMARY_2,
      color: COLOR_PRIMARY_2,
    },
  };


  const styles = {
    commonButtonSx,
    containedButtonSx,
    outlinedButtonSx,
  }

  export default styles;